// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_jr-0";
export var discountCodeInput = "_jr-1";